import { NavLink } from 'react-router-dom';
import { useNavigationStore } from '../../stores/navigationStore';
import { NAVIGATION_CONFIG } from '../../config/navigationConfig';
import { cn } from '../../lib/utils';

export function Sidebar() {
  const { sidebarOpen } = useNavigationStore();

  return (
    <aside
      className={cn(
        'fixed left-0 top-16 z-40 h-[calc(100vh-4rem)] border-r border-slate-700 bg-slate-800 transition-all duration-300',
        sidebarOpen ? 'w-60' : 'w-16'
      )}
    >

      {/* Navigation */}
      <nav className="h-full overflow-y-auto p-4">
        {NAVIGATION_CONFIG.map((section) => (
          <div key={section.id} className="mb-6">
            {sidebarOpen && (
              <div className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-slate-400">
                {section.label}
              </div>
            )}
            <div className="space-y-1">
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.id}
                    to={item.path}
                    className={({ isActive }) =>
                      cn(
                        'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                        isActive
                          ? 'bg-primary text-white'
                          : 'text-slate-300 hover:bg-slate-700',
                        !sidebarOpen && 'justify-center'
                      )
                    }
                    title={!sidebarOpen ? item.label : undefined}
                  >
                    <Icon className="h-5 w-5 flex-shrink-0" />
                    {sidebarOpen && (
                      <span className="truncate">{item.label}</span>
                    )}
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
}
